import { COLUMN_CONSTRAINTS } from "../app/newLayout/page/utils/tableDataElements";
import { formatColumnLabel } from "./columnLabel";
import { TABLE_HEADER_MEASURE_FONT } from "../components/atoms/Table/tableTypography.styles";

export { COLUMN_CONSTRAINTS };

const canvas = typeof document !== "undefined" ? document.createElement("canvas") : null;
const getCtx = () => canvas?.getContext("2d") ?? null;

const PADDING_X = 32;
const ICON_SIZE = 12;
const GAP = 8;

/**
 * Minimum width so the header label and optional sort/filter icons fit.
 */
export const measureHeaderMinWidth = ({
  label,
  hasSort = false,
  hasFilter = false,
} = {}) => {
  const ctx = getCtx();
  let textWidth = 60;
  if (ctx && label) {
    ctx.font = `${TABLE_HEADER_MEASURE_FONT}, sans-serif`;
    textWidth = ctx.measureText(formatColumnLabel(label)).width;
  }
  let overhead = PADDING_X;
  if (hasSort) overhead += ICON_SIZE + GAP;
  if (hasFilter) overhead += GAP + ICON_SIZE;
  return Math.ceil(textWidth + overhead);
};

export const clampColumnWidth = (
  width,
  minWidth = COLUMN_CONSTRAINTS.MIN_WIDTH,
  maxWidth = COLUMN_CONSTRAINTS.MAX_WIDTH,
) =>
  Math.max(
    minWidth,
    Math.min(Math.min(COLUMN_CONSTRAINTS.MAX_WIDTH, maxWidth), Math.round(width)),
  );
